import { CheckPricingResponse } from "../models/checkPricingResponse";
import http from "../http/http-config";

export default new class checkPricingService {
    checkStatePricing(pricingId): Promise<CheckPricingResponse> {
        return http.get<CheckPricingResponse>("CheckPricing", {
            params: {
                pricingId
            }
        }).then(response => response.data)
    }
}
